
/* styles */
require("!!../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../vue-loader/lib/style-compiler/index?{\"id\":\"data-v-194b042f\",\"scoped\":true,\"hasInlineConfig\":false}!../../vux-loader/src/style-loader.js!../../vue-loader/lib/selector?type=styles&index=0!./crop.vue")

var Component = require("!../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../vux-loader/src/script-loader.js!../../vue-loader/lib/selector?type=script&index=0!./crop.vue"),
  /* template */
  require("!!../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-194b042f\"}!../../vux-loader/src/template-loader.js!../../vue-loader/lib/selector?type=template&index=0!./crop.vue"),
  /* scopeId */
  "data-v-194b042f",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-core-image-upload/dist/crop.vue
// module id = 567
// module chunks = 4